/**
 * One category list for the ledger (sheet-friendly). Stored values stay
 * backwards compatible with what Finance and the importer already write.
 */
export const LEDGER_CATEGORIES = [
  { value: "rent", label: "Rent", income: true },
  { value: "mortgage", label: "Mortgage" },
  { value: "maintenance", label: "Repair & maintenance" },
  { value: "utilities", label: "Utilities" },
  { value: "insurance", label: "Insurance" },
  { value: "property tax", label: "Tax" },
  { value: "hoa", label: "HOA" },
  { value: "credit card payment", label: "Credit card" },
  { value: "bank fee", label: "Bank fee" },
  { value: "other", label: "Other" },
];

export const EXPENSE_CATEGORY_OPTIONS = LEDGER_CATEGORIES.filter((c) => !c.income);

const LABELS = Object.fromEntries(LEDGER_CATEGORIES.map((c) => [c.value, c.label]));
const ALIASES = {
  repair: "maintenance",
  repairs: "maintenance",
  "credit card": "credit card payment",
  "credit bills": "credit card payment",
  tax: "property tax",
  taxes: "property tax",
  business: "other",
};

export function normalizeCategory(value) {
  const key = String(value ?? "").trim().toLowerCase();
  if (!key) return "other";
  if (LABELS[key]) return key;
  return ALIASES[key] || key;
}

export function categoryLabel(value) {
  const key = normalizeCategory(value);
  if (LABELS[key]) return LABELS[key];
  return key.charAt(0).toUpperCase() + key.slice(1);
}
